export default [
    {
        path: '/processes',
        name: 'Processes_Inbox',
        component: () => import('@/views/processes/inbox.vue'),
        meta: {
            authRequired: true,
            permission: 'processes.index'
        }
    },

    {
        path: '/processes/create',
        name: 'Processes_Create',
        component: () => import('@/views/processes/create.vue'),
        meta: {
            authRequired: true,
            permission: 'processes.store'
        }
    },
    {
        path: '/processes/:id',
        name: 'Processes_Detail',
        component: () => import('@/views/processes/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'processes.show',
            navActiveLink: 'Processes_Inbox',
        }
    },
]
